class GalleryController {
  constructor (Image, Upload, SERVER_URL, ModelFactory, growl) {
    'ngInject'

    let vm = this
    let modalInstance
    // vm.openImageDetail = Image.openDetail;
    vm.openImageDetail = function (imageSource, imageId) {
      modalInstance = Image.openDetail(imageSource, imageId, vm.reinit)
    }

    vm.test = function () {
      console.log(ModelFactory.getModel(vm.item))
    }

    vm.uploadFile = function (file) {
      if (file) {
        Upload.upload({
          url: SERVER_URL + '/images-with-multipart',
          data: {
            file: file,
            fileName: file.name,
            modelName: ModelFactory.getModel(vm.item).enum,
            id: _.get(vm.item, ModelFactory.getModel(vm.item).name + '.id'),
          },
        }).then(
          function suc (response) {
            console.log('Success %o', response)
            growl.success('Immagine caricata con successo!')
            //self.model.image = response.data.result[0].name;
            refreshDetail()
          },

          function err (response) {
            console.log('Error: %o', response)
            alert('Couldn\'t upload file')
          },

          function prg (e) {
            var progressPercentage = parseInt(100.0 * e.loaded / e.total)
            vm.percent = progressPercentage
            //console.log(e);
          },
        )
      }

    }

    function deleteCallback () {
      modalInstance.result.close()
      refreshDetail()
    }

    function refreshDetail () {
      if (_.isFunction(vm.reinit)) {
        vm.reinit()
      }
    }
  }
}

export default GalleryController



// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/gallery/gallery.controller.js